export default __webpack_public_path__ + "static/media/qrcode-circle-color.88d08978.svg";